<template lang='pug'>
  v-combobox(:value='value'
    @input='update'
    :items='items'
    :search-input.sync='search'
    hide-selected
    :label='label'
    multiple
    chips
    deletable-chips
    small-chips
    persistent-hint)
    template(v-slot:no-data)
      v-list-item
        v-list-item-content
          v-list-item-title
            | No tags matching &quot;
            strong {{ search }}
            | &quot;. Press&nbsp;
            kbd enter
            |  to create a new one

</template>

<script>
import _ from 'lodash';
import Tag from '../api/tag';


export default {
  name: 'Tags',
  async mounted() {
    await this.load();
  },
  props: {
    label: {
      default() {
        return 'Add some tags';
      }
    },
    value: {
      default() {
        return [];
      }
    }
  },
  methods: {
    async load() {
      if (this.loading) return; // already loading
      if (this.items && this.items.length) return; // already loaded
      try {
        this.loading = true;
        this.items = await Tag.list();
      } catch (e) {
        console.error(`Error loading tags: ${e}`);
        throw e;
      } finally {
        this.loading = false;
      }
    },
    update(value) {
      this.$emit('input', value.sort());
    }
  },
  watch: {
    // eslint-disable-next-line
    search: _.debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      items: [],
      search: null,
      loading: false
    };
  }
};
</script>

<style scoped>

</style>
